<script setup>
import { BCard, BLink, BProgress, BProgressBar } from 'bootstrap-vue-next';

import { LEVEL_POINTS } from '~/common/Constants';
import { useVueData } from '~/common/useVueData';

import PointsDocumentationTooltip from './PointsDocumentationTooltip.vue';

const props = defineProps({
  minimized: {
    type: Boolean,
    default: false,
  },
  contributorData: {
    type: Object,
    default: () => null,
  },
});

let approvedCommunityMember;
let contributorLevel;
let contributorPoints;
if (props.contributorData != null) {
  ({ contributorLevel, contributorPoints } = props.contributorData);
} else {
  ({ approvedCommunityMember, contributorLevel, contributorPoints } = useVueData());
}

const MAX_LEVEL = 5;
const levelStart = LEVEL_POINTS[contributorLevel];
const levelEnd = contributorLevel === MAX_LEVEL ? LEVEL_POINTS[MAX_LEVEL] : LEVEL_POINTS[contributorLevel + 1];
let total = levelEnd - levelStart;
let progress = contributorPoints - levelStart;
const needsOnboardingToLevelUp = approvedCommunityMember === false
  && contributorLevel !== MAX_LEVEL
  && contributorPoints >= LEVEL_POINTS[contributorLevel + 1];

if (progress < 0) {
  total = levelEnd;
  progress = contributorLevel === MAX_LEVEL ? levelEnd : contributorPoints;
}
</script>

<template>
  <BProgress
    v-if="minimized"
    :max="total"
  >
    <BProgressBar
      :value="progress"
      class="text-center level-up"
    />
  </BProgress>
  <BCard
    v-else
    class="overflow-hidden my-2"
    title="Unlock the next achievement!"
  >
    <div
      class="d-flex"
      data-test-id="progress-bar-subtitle"
    >
      <span v-if="needsOnboardingToLevelUp">
        <BLink
          :to="{
            name: 'home',
            hash: '#start',
          }"
        >
          Start onboarding
        </BLink>
        to level up!
      </span>
      <span v-else-if="contributorLevel < MAX_LEVEL">
        <b>Level {{ contributorLevel + 1 }}</b> in {{ Math.ceil(total - progress).toLocaleString() }} points
      </span>
      <span v-else-if="contributorData == null">
        You're a top contributor! {{ contributorPoints.toLocaleString() }} points.
      </span>
      <span v-else>
        Top contributor! {{ contributorPoints.toLocaleString() }} points
      </span>
      <PointsDocumentationTooltip />
    </div>
    <div class="py-2">
      <BProgress
        :max="total"
        height="2rem"
      >
        <BProgressBar
          :value="progress"
          class="level-up"
        />
      </BProgress>
    </div>
    <div>
      <BLink :to="{ name: 'issues' }">
        Explore issues to contribute
      </BLink>
    </div>
  </BCard>
</template>
